import React from "react";
import "./WorkflowSection.css";
import { FaShoppingBag, FaStoreAlt, FaLeaf } from "react-icons/fa";

const WorkflowSection = () => {
    return (
        <section className="workflow-section-container">
            <div className="workflow-section-content">
                <h2 className="_hTitle_s5E_ workflow-title">A Simple, Honest Experience</h2>
                <p className="workflow-subtitle _hSubtitle_t6F_">
                    See how Vanidya brings together mindful customers, responsible sellers, and our team to deliver pure products—transparently and efficiently.
                </p>
                <div className="workflow-cards-wrapper">

                    {/* Buyer / Customer Card */}
                    <div className="workflow-card">
                        <div className="card-icon-wrapper">
                            <FaShoppingBag className="card-icon" />
                        </div>
                        <h3 className="card-title">For Customers</h3>
                        <ul className="card-list">
                            <li>Discover hyperlocal sellers</li>
                            <li>Sign up quickly with your mobile and address.</li>
                            <li>Browse Satvik groceries, Organic essentials, pooja items and books.</li>
                            <li>See clear ingredient, origin, and certification info before buying.</li>
                            <li>Order easily and pay securely with no hidden charges.</li>
                            <li>Receive products promptly—fresh and well-packed for you.</li>
                        </ul>
                    </div>

                    {/* Seller Card */}
                    <div className="workflow-card">
                        <div className="card-icon-wrapper">
                            <FaStoreAlt className="card-icon" />
                        </div>
                        <h3 className="card-title">For Sellers</h3>
                        <ul className="card-list">
                            <li>Register your shop and upload products with required info and certifications.</li>
                            <li>List Satvik, Organic and pooja essentials for conscious buyers.</li>
                            <li>Manage orders, track payments and handle deliveries efficiently.</li>
                            <li>Build trust with accurate listings and quality service.</li>
                            <li>Reach a loyal, mindful customer base through Vanidya.</li>
                        </ul>
                    </div>

                    {/* Platform / Vanidya Card */}
                    <div className="workflow-card">
                        <div className="card-icon-wrapper">
                            <FaLeaf className="card-icon" />
                        </div>
                        <h3 className="card-title">For Vanidya</h3>
                        <ul className="card-list">
                            <li>Review and approve product listings for quality, purity, and transparency.</li>
                            <li>Support sellers and buyers with clear policies and responsive service.</li>
                            <li>Maintain honest, up-to-date product information throughout the platform.</li>
                            <li>Encourage mindful, sustainable shopping for everyone.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WorkflowSection;